import { loadAuth2WithProps } from "gapi-script";

import { getEnvString } from "@megaron/get-env-var";

export const getGoogleAuth = (scope = "profile email openid") =>
  loadAuth2WithProps(gapi, {
    client_id: process.env["NX_PUBLIC_GOOGLE_CLIENT_ID"],
    scope,
    ux_mode: "popup",
  });
